import { MdOutlineCardGiftcard } from "react-icons/md";
import { Badge, Card } from "../crm/Primitives";
import { formatNumber } from "../crm/crmHelpers";
import {
  describeGiftRemaining,
  describeGiftRule,
  giftStockTone,
} from "./eventHelpers";

/*
  Brindes do evento: quanto chegou, quanto já saiu e quanto sobra, com a regra
  que liga cada brinde aos planos. O saldo cai sozinho a cada plano pago (não há
  botão de entregar); se a equipe cobrou sem estoque, o saldo fica negativo e a
  linha mostra quantos brindes estão devendo.

  Sem brindes cadastrados o cartão não aparece: evento sem brinde não precisa de
  mais uma caixa na tela. O cadastro fica em "Editar".
*/

const EventGiftsCard = ({ event, onEdit }) => {
  const gifts = event.gifts || [];

  if (!gifts.length) {
    return (
      <p className="px-1 text-xs text-slate-500">
        Este evento não tem brindes.{" "}
        <button
          type="button"
          onClick={onEdit}
          className="font-semibold text-pink-700 underline"
        >
          Cadastrar brindes
        </button>
      </p>
    );
  }

  return (
    <Card className="p-4">
      <div className="mb-3 flex items-start justify-between gap-3">
        <div className="min-w-0">
          <h2 className="flex items-center gap-1.5 text-base font-bold text-slate-900">
            <MdOutlineCardGiftcard size={18} className="text-pink-600" /> Brindes
          </h2>
          <p className="text-xs text-slate-500">
            O estoque diminui sozinho quando o pagamento do plano entra.
          </p>
        </div>
        <button
          type="button"
          onClick={onEdit}
          className="shrink-0 text-xs font-semibold text-pink-700 underline"
        >
          Editar brindes
        </button>
      </div>

      <ul className="divide-y divide-slate-100">
        {gifts.map((gift) => (
          <li
            key={gift.id}
            className="flex flex-col gap-1 py-2.5 sm:flex-row sm:items-center sm:justify-between sm:gap-4"
          >
            <div className="min-w-0">
              <p className="break-words text-sm font-bold text-slate-900">
                {gift.name}
              </p>
              <p className="text-xs text-slate-500">
                {gift.rules.length
                  ? gift.rules
                      .map(
                        (rule) =>
                          `${rule.quantity} para ${describeGiftRule(rule)}`
                      )
                      .join(" · ")
                  : "Sem regra: nenhum plano dá este brinde"}
              </p>
            </div>

            <div className="flex shrink-0 flex-wrap items-center gap-2 text-xs text-slate-600">
              <span>
                {formatNumber(gift.delivered)} de {formatNumber(gift.stock)}{" "}
                entregues
              </span>
              <Badge tone={giftStockTone(gift)}>
                {describeGiftRemaining(gift.remaining)}
              </Badge>
            </div>
          </li>
        ))}
      </ul>
    </Card>
  );
};

export default EventGiftsCard;
